import React from 'react';
import './Footer.css';
import SocialLinks from "../SocialLinks/SocialLinks";
import Wrapper from "../Wrapper/Wrapper";
import FloatingWhatsApp from "../FloatingWhatsApp/FloatingWhatsApp";
import ScrollToTop from "react-scroll-to-top";
import {useTranslation} from "react-i18next";

function Footer(props) {
    const { t } = useTranslation();
    return (
        <Wrapper>
            <footer>
                <SocialLinks orientation={'horizontal'}/>
                <hr/>
                <p>Lautaro Aguirre &copy; 2025. {t('ALL RIGHTS RESERVED.')}</p>
            </footer>


            <FloatingWhatsApp/>
            <ScrollToTop smooth color={"dodgeblue"} />
        </Wrapper>

    );
}

export default Footer;